import { useCallback } from 'react';
import useServiceClients from './useServiceClients';
import { useConfig } from '../../providers/config-provider';

export interface logObjectType {
  logType: string;
  data: any;
}
const useSplunkLogger = (useProxy = false) => {
  const { ctproxyBffClient: ctproxyBffClientWithoutLoader } = useServiceClients(false);
  const { config } = useConfig();
  const SPLUNK_UI_LEVEL = config?.services?.splunk_UI_level?.level || 'debug';

  const splunkLogger = useCallback((logObject: logObjectType) => {
    const url = useProxy ? '/proxy/api/v1/splunklogger' : '/api/v1/splunklogger';
    try {
      const { logType } = logObject;
      const severityLevels = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'];

      const shouldLog = severityLevels.indexOf(logType) >= severityLevels.indexOf(SPLUNK_UI_LEVEL);
      if (!shouldLog) {
        return true; // Skip logging
      }

      ctproxyBffClientWithoutLoader({
        method: 'POST',
        url,
        data: logObject,
      });
      return true;
    } catch (error) {
      console.log('splunk logger error', error);
      throw error;
    }
  }, [SPLUNK_UI_LEVEL, ctproxyBffClientWithoutLoader, useProxy]);
  return { splunkLogger };
};

export default useSplunkLogger;
